<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <!-- Price & Currency Section -->

            <b-row>
              <b-col cols="3">
                <h4 class="card-title mb-4">Price In:</h4>

                <multiselect
                  v-model="priceIn"
                  :options="priceInArr"
                  @input="onChangePriceIn(priceIn)"
                ></multiselect>
              </b-col>

              <b-col cols="3">
                <h4 class="card-title mb-4">Currency:</h4>

                <multiselect
                  v-model="currency"
                  track-by="currency"
                  label="currency"
                  :options="currencyArr"
                ></multiselect>
              </b-col>
              <b-col cols="3">
                <div class="text-center">
                  <h4 class="card-title mb-4">Current Price:</h4>

                  <h4 :style="'color:' + color">
                    {{ currentPrice != null ? currentPrice : "-" }}
                  </h4>
                </div>
              </b-col>

              <b-col cols="3">
                <h4 class="card-title mb-4">Get Price:</h4>

                <button
                  style="width:111px"
                  v-if="loading"
                  class="btn btn-primary"
                >
                  <b-spinner small label="Loading..."></b-spinner>
                </button>
                <button
                  v-else
                  :disabled="currency && priceIn ? false : true"
                  @click="getPrice"
                  class="btn btn-primary"
                >
                  Get Live Price
                </button>
              </b-col>
            </b-row>

            <!-- Show Current Price Section -->

            <div class="row mt-4">
              <div class="col-lg-12">
                <!-- Show Socket Data hete                 -->

                <div class="row mt-4">
                  <!-- <div class="col-2 text-center">
                    <label for="inlineFormInputName2">Current Price</label>

                    <h4 :style="'color:' + color">
                      {{ currentPrice != null ? currentPrice : "-" }}
                    </h4>
                  </div> -->

                  <div class="col-3 text-center">
                    <label for="inlineFormInputName3">ORDER TYPE</label>
                    <multiselect
                      v-model="pump_dump_type"
                      :options="pump_dump_arr"
                    ></multiselect>
                  </div>
                  <div class="col-3 text-center">
                    <label for="inlineFormInputName3">Pump Dump Price</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="pump_dump_price"
                      placeholder=" Pump Dump Price "
                      onkeypress="return (event.charCode !=8 && ((event.charCode >= 48 && event.charCode <= 57) || (event.charCode == 46 && this.value.indexOf('.') == -1)))"
                      onpaste="return false;"
                    />
                  </div>
                  <div class="col-2 text-center">
                    <div class="text-center">
                      <h4 class="card-title mb-4">Total Volume:</h4>

                      <h4 style="'color:green">
                        {{
                          totalQTY != null
                            ? totalQTY + " " + currency.currency
                            : "-"
                        }}
                      </h4>
                    </div>
                  </div>

                  

                  <div class="col-2 text-center">
                    <div class="text-center">
                      <h4 class="card-title mb-4">Available Volume :</h4>

                      <h4 style="'color:green">
                        {{
                          totalCrypto != null
                            ? pump_dump_type == "DOWN"
                              ? totalCrypto + " " + currency.currency
                              : totalCrypto + " " + currency.pair_with
                            : "-"
                        }}
                      </h4>
                    </div>
                  </div>
                  <div class="col-2 ">
                    <button
                      style="width:111px"
                      v-if="loading1"
                      class="btn btn-primary"
                    >
                      <b-spinner small label="Loading..."></b-spinner>
                    </button>
                    <button
                      v-else
                      :disabled="
                        currency &&
                        priceIn &&
                        currentPrice &&
                        pump_dump_type &&
                        pump_dump_price
                          ? false
                          : true
                      "
                      @click="getVolume"
                      class="btn btn-primary"
                    >
                      Get Total Volume
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Buy/Sell Section -->

    <b-row>
      <b-col md="6" offset-md="3">
        <div class="card">
          <div class="card-body">
            <div class="mt-4">
              <b-tabs nav-class="bg-light rounded" pills content-class="mt-4">
                <b-tab title="Buy" active>
                  <!-- <h5 class="font-size-14 mb-4">Buy Coin</h5> -->

                  <div>
                    <div>
                      <!-- <label>Add Price :</label> -->

                      <div class="input-group mb-3">
                        <label class="input-group-text">Price</label>
                        <!-- 
                        <b-form-select
                          v-model="form.amount_type"
                          :options="amountTypeArr"
                          @input="amountType(form.amount_type)"
                        ></b-form-select> -->

                        <input
                          type="text"
                          class="form-control"
                          v-model="form.min"
                          :placeholder="form.amount_type == 'range'"
                          onkeypress="return (event.charCode !=8 && ((event.charCode >= 48 && event.charCode <= 57) || (event.charCode == 46 && this.value.indexOf('.') == -1)))"
                          onpaste="return false;"
                        />

                        <input
                          type="text"
                          class="form-control"
                          v-model="form.max"
                          v-if="form.amount_type == 'range'"
                          placeholder="Max"
                          onkeypress="return (event.charCode !=8 && ((event.charCode >= 48 && event.charCode <= 57) || (event.charCode == 46 && this.value.indexOf('.') == -1)))"
                          onpaste="return false;"
                        />

                        <div class="input-group-append">
                          <!-- <label >$</label> -->

                          <button
                            @click="form.min = currentPrice"
                            class="input-group-text"
                          >
                            Current Price
                          </button>
                        </div>
                      </div>

                      <div class="input-group mb-3">
                        <div class="input-group-prepend">
                          <label class="input-group-text">Quantity</label>
                        </div>
                        <!-- <b-form-select
                          v-model="form.qty_type"
                          :options="amountTypeArr"
                          @input="amountType(form.qty_type)"
                        ></b-form-select> -->
                        <input
                          type="text"
                          v-model="form.qty_min"
                          class="form-control"
                          :placeholder="form.qty_type == 'range'"
                          onkeypress="return (event.charCode !=8 && ((event.charCode >= 48 && event.charCode <= 57) || (event.charCode == 46 && this.value.indexOf('.') == -1)))"
                          onpaste="return false;"
                        />

                        <input
                          type="text"
                          class="form-control"
                          v-model="form.qty_max"
                          v-if="form.qty_type == 'range'"
                          placeholder="Max"
                          onkeypress="return (event.charCode !=8 && ((event.charCode >= 48 && event.charCode <= 57) || (event.charCode == 46 && this.value.indexOf('.') == -1)))"
                          onpaste="return false;"
                        />
                      </div>

                      <!-- <div class="input-group mb-3">
                        <div class="input-group-prepend">
                          <label class="input-group-text">No Of Orders</label>
                        </div>

                        <input
                          type="text"
                          v-model="form.total_orders"
                          class="form-control"
                          onkeypress="return (event.charCode !=8 && ((event.charCode >= 48 && event.charCode <= 57) || (event.charCode == 46 && this.value.indexOf('.') == 0)))"
                          onpaste="return false;"
                        />
                      </div> -->
                    </div>

                    <div class="text-center">
                      <button
                        :disabled="currency && priceIn ? false : true"
                        type="button"
                        @click="submitForm('buy')"
                        class="btn btn-success w-md"
                      >
                        Buy Coin
                      </button>
                    </div>
                  </div>
                </b-tab>

                <b-tab title="Sell">
                  <!-- <h5 class="font-size-14 mb-4">Sell Coin</h5> -->

                  <div>
                    <div>
                      <!-- <label>Add Amount:</label> -->

                      <div class="input-group mb-3">
                        <label class="input-group-text">Amount</label>

                        <!-- <b-form-select
                          v-model="form.amount_type"
                          :options="amountTypeArr"
                          @input="amountType(form.amount_type)"
                        ></b-form-select> -->
                        <input
                          type="text"
                          class="form-control"
                          v-model="form.min"
                          :placeholder="form.amount_type == 'range'"
                          onkeypress="return (event.charCode !=8 && ((event.charCode >= 48 && event.charCode <= 57) || (event.charCode == 46 && this.value.indexOf('.') == -1)))"
                          onpaste="return false;"
                        />

                        <input
                          type="text"
                          class="form-control"
                          v-model="form.max"
                          v-if="form.amount_type == 'range'"
                          placeholder="Max"
                          onkeypress="return (event.charCode !=8 && ((event.charCode >= 48 && event.charCode <= 57) || (event.charCode == 46 && this.value.indexOf('.') == -1)))"
                          onpaste="return false;"
                        />
                        <div class="input-group-append">
                          <!-- <label >$</label> -->

                          <button
                            @click="form.min = currentPrice"
                            class="input-group-text"
                          >
                            Current Price
                          </button>
                        </div>
                      </div>

                      <div class="input-group mb-3">
                        <div class="input-group-prepend">
                          <label class="input-group-text">Quantity</label>
                        </div>
                        <!-- <b-form-select
                          v-model="form.qty_type"
                          :options="amountTypeArr"
                          @input="amountType(form.qty_type)"
                        ></b-form-select> -->
                        <input
                          type="text"
                          v-model="form.qty_min"
                          class="form-control"
                          :placeholder="form.qty_type == 'range'"
                          onkeypress="return (event.charCode !=8 && ((event.charCode >= 48 && event.charCode <= 57) || (event.charCode == 46 && this.value.indexOf('.') == -1)))"
                          onpaste="return false;"
                        />

                        <input
                          type="text"
                          class="form-control"
                          v-model="form.qty_max"
                          v-if="form.qty_type == 'range'"
                          placeholder="Max"
                          onkeypress="return (event.charCode !=8 && ((event.charCode >= 48 && event.charCode <= 57) || (event.charCode == 46 && this.value.indexOf('.') == -1)))"
                          onpaste="return false;"
                        />
                      </div>

                      <!-- <div class="input-group mb-3">
                        <div class="input-group-prepend">
                          <label class="input-group-text">No Of Orders</label>
                        </div>

                        <input
                          type="text"
                          v-model="form.total_orders"
                          class="form-control"
                          onkeypress="return (event.charCode !=8 && ((event.charCode >= 48 && event.charCode <= 57) || (event.charCode == 46 && this.value.indexOf('.') == 0)))"
                          onpaste="return false;"
                        />
                      </div> -->
                    </div>

                    <div class="text-center">
                      <button
                        :disabled="currency && priceIn ? false : true"
                        @click="submitForm('sell')"
                        type="button"
                        class="btn btn-danger w-md"
                      >
                        Sell Coin
                      </button>
                    </div>
                  </div>
                </b-tab>
              </b-tabs>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
  </Layout>
</template>

<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Multiselect from "vue-multiselect";
import ApiClass from "../../../api/api";
import Swal from "sweetalert2";

/**
 * Buy/Sell component
 */
export default {
  page: {
    title: "Buy/Sell",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Multiselect },
  data() {
    return {
      totalQTY: null,
      priceInCurrency:"",
      pump_dump_price: null,
      pump_dump_type: null,
      pump_dump_arr: ["UP", "DOWN"],
      totalCrypto: null,
      color: "black",
      currentPrice: null,
      oldPrice: null,
      changePrice: null,
      changePriceShow: true,
      connection: "",
      check: true,
      loading: false,
      loading1: false,
      oldPair: "",
      conv_rate: "",

      title: "Buy/Sell",
      items: [
        {
          text: "Buying & Selling",
          href: "/",
        },
        {
          text: "Buy/Sell",
          active: true,
        },
      ],

      form: {
        qty_type: "exact",
        amount_type: "exact",
        min: null,
        max: null,
        qty_min: null,
        qty_max: null,
        total_orders: null,
      },

      priceIn: "",
      priceInArr: [],
      currency: "",
      currencyArr: [],
      response: [],

      amountTypeArr: [
        { value: "exact", text: "Exact" },
        { value: "range", text: "Range" },
      ],
      show: false,
    };
  },
  mounted() {
    this.usersCrypto();
    //  this.getSelectCurrencyPrice('BTCUSDT')
  },

  methods: {
    // for submit form
    async submitForm(type) {
      //   at_price: 68
      // currency: "FNX"
      // order_type: "buy"
      // quantity: 10
      // stop_price: 0
      // total: 680
      // type: "limit"
      // with_currency: "USDT"
      var formData = {
        at_price: this.form.min,
        currency: this.currency.currency,
        with_currency: this.currency.pair_with,
        quantity: this.form.qty_min,
        order_type: type,
        type: "limit",
        total: this.form.min * this.form.qty_min,
      };

      var result = await ApiClass.postNodeRequest(
        "orders/place-order",
        true,
        formData
      );
      console.log({ result });
      if (result.data.status_code == 1) {
        this.showMsg("success", result.data.message);
        this.clearData();
      } else {
        this.showMsg("error", result.data.message);
      }
    },

    // for buy coin
    async buyCoin() {
      var formData = this.returnFormData("buy");

      var result = await ApiClass.postRequest(
        "admin/order/create",
        true,
        formData
      );
      if (result.data.status_code == 1) {
        this.showMsg("success", result.data.message);
        this.clearData();
      } else {
        this.showMsg("error", result.data.message);
      }
      // console.log(result);
    },

    async sellCoin() {
      var formData = this.returnFormData("sell");
      var result = await ApiClass.postRequest(
        "admin/order/create",
        true,
        formData
      );
      if (result.data.status_code == 1) {
        this.showMsg("success", result.data.message);
        this.clearData();
      } else {
        this.showMsg("error", result.data.message);
      }
    },
    showMsg(msg, data) {
      Swal.fire({
        position: "center",
        icon: msg,
        title: data,
        showConfirmButton: false,
        timer: 4000,
      });
    },
    returnFormData(type) {
      var formData = new FormData();

      formData.append("currency", this.currency.currency);
      formData.append("with_currency", this.currency.pair_with);
      formData.append("amount_type", this.form.amount_type);
      if (this.form.max != null) {
        formData.append("max", this.form.max);
      }
      if (this.form.qty_max != null) {
        formData.append("qty_max", this.form.qty_max);
      }
      formData.append("min", this.form.min);
      formData.append("qty_type", this.form.qty_type);
      formData.append("qty_min", this.form.qty_min);
      formData.append("total_orders", this.form.total_orders);
      formData.append("order_type", type);

      return formData;
    },
    clearData() {
      (this.form.qty_type = ""),
        (this.form.amount_type = ""),
        (this.form.min = ""),
        (this.form.max = ""),
        (this.form.qty_min = ""),
        (this.form.qty_max = ""),
        (this.form.total_orders = "");
    },
    async usersCrypto() {
      var result = await ApiClass.getRequest("admin/crypto/pairs/get", true);
      if (result.data.status_code == 1) {
        this.priceInArr = Object.keys(result.data.data);
        //console.log("priceInArr =", this.priceInArr);
        this.response = result.data.data;
      }
    },
    onChangePriceIn(priceval) {
      this.currency = "";
      //console.log("response=", this.response);
      if (priceval != null) this.currencyArr = this.response[priceval];
      // console.log("currencyArr=", this.currencyArr);
    },
    getPrice() {
      var currency = this.currency.currency;
      var initial_pair = this.priceIn;
      this.getListedCurrencyPrice(currency, initial_pair);
      this.loading = true;
    },

    amountType(type) {
      if (type == "range") {
        this.show = true;
      } else {
        this.show = false;
      }
    },

    async getListedCurrencyPrice(currency, initial_pair) {
      var param = {
        currency: currency,
        pair_with: initial_pair,
      };
      var result = await ApiClass.getRequest(
        "admin/list-coins/live_price",
        true,
        null,
        param
      );
      var $this = this;
      if (result.data.status_code == 1) {
        $this.loading = false;
        $this.currentPrice = parseFloat(result.data.data.current_price);
        $this.changePrice = null;
        $this.changePriceShow = false;
        $this.color = "green";
      } else {
        $this.loading = false;
        this.showMsg("error", result.data.message);
      }
    },
    async getVolume() {
      this.loading1 = true;
      var info = {
        currency: this.currency.currency,
        pair_with: this.priceIn,
        type: this.pump_dump_type,
        current_price: this.currentPrice,
        pump_dump_price: this.pump_dump_price,
      };
      var result = await ApiClass.postNodeRequest(
        "orders/admin_order_info",
        true,
        info
      );
      this.loading1 = false;
      if (result.data.status_code == 1) {
        this.totalQTY = result.data.data.total_quantity;
        this.priceInCurrency = (this.pump_dump_type == 'UP') ? this.priceIn : this.currency.currency;

        return (this.totalCrypto = result.data.data.user_crypto);
      }
      this.showMsg("error", result.data.message);
    },
  },

  destroyed: function() {
    if (this.connection) {
      console.log("closed");
      this.connection.close();
    }
  },
};
</script>
